import { render, staticRenderFns } from "./MergeLangsModal.vue?vue&type=template&id=42b56cca"
import script from "./MergeLangsModal.vue?vue&type=script&lang=js"
export * from "./MergeLangsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports